(function () {
  const initScrollProducts = () => {
    const sections = document.querySelectorAll(".section-scroll-products");

    sections.forEach((section) => {
      if (section.classList.contains("scroll_initialized")) {
        return;
      }
      section.classList.add("scroll_initialized");

      const parent = section.querySelector(".scroll-products__container");
      const child = section.querySelector(".scroll-products");
      const innerDiv = child.querySelector(".scroll-products__products");
			const productCard = section.querySelector(".scroll-products__item");
			const wrapper = section.querySelector(".scroll-products__wrapper");
			const productsCount = +child.dataset.productsCount;
      const isSingleProduct = productsCount == 1;
			const childBefore = window.getComputedStyle(child, "::before");
			const slideHeight = parseFloat(childBefore.height);

			//if (productCard) {
			//	let productCardHeight = productCard.offsetHeight + 96;
			//	if (productCardHeight < slideHeight) {
			//		productCardHeight = slideHeight;
			//	}
			//	child.style.minHeight = `${productCardHeight}px`;
			//}
			const updateMinHeight = () => {
				if (productCard) {
					wrapper.style.maxHeight = `${productCard.offsetHeight}px`;
					let productCardHeight = productCard.offsetHeight + 96;
					if (productCardHeight < slideHeight) {
						productCardHeight = slideHeight;
					}
					if (parseInt(child.style.minHeight) !== productCardHeight) {
						child.style.minHeight = `${productCardHeight}px`;
					}
				}
			};
			updateMinHeight();
			

      if (!parent || !child || !innerDiv) return;

      const handleScroll = () => {
        const parentRect = parent.getBoundingClientRect();
        const childRect = child.getBoundingClientRect();

        const startScroll = parentRect.top + window.scrollY;
        const endScroll = parentRect.bottom - childRect.height + window.scrollY;

        const isSmallScreen = window.innerWidth < 990;
				const isMediumScreen = window.innerWidth < 1360;

        const scrolled = Math.min(
          Math.max((window.scrollY - startScroll) / (endScroll - startScroll), 0),
          1
        );

        let translateY = -110 + 110 * scrolled;
        let translateX = -50;

				if (productsCount == 4 && !isSmallScreen) {
					translateY = -50;
					translateX = !isMediumScreen ? 70 - 70 * scrolled : 76 - 76 * scrolled;
				} else if (productsCount != 4 && !isSmallScreen && !isSingleProduct) {
						translateY = -50;
						translateX = !isMediumScreen ? 60 - 60 * scrolled : 67 - 67 * scrolled;
				} else if (!isSmallScreen && isSingleProduct) {
						translateX = 0;
						translateY = -50 * scrolled;
				}

        innerDiv.style.transform = `translate(${translateX}%, ${translateY}%)`;
      };

      const handleResize = () => {
        handleScroll();
				updateMinHeight();
      };

      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleResize);

      handleScroll();
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    initScrollProducts();
    document.addEventListener("shopify:section:load", () => {
      initScrollProducts();
    });
  });
})();
